import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';
import { placeSetSchema } from '../schemas/place-set.schema';

/**
 * Gets Place Sets assigned to a specific vehicle group
 * @param vehicleGroupId Vehicle Group ID of group whose Place Sets are being requested
 * @returns Array of IDs
 */
export function getVehicleGroupsIdPlaceSets(
  this: unknown,
  vehicleGroupId: number
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          fleetEnvironment.resolve(this).placeSetsVehicleGroupsUrl
        }?vehicleGroupIds=${String(vehicleGroupId)}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.array(placeSetSchema.omit({ vehicleGroups: true })),
      })
    )
  );
}
